var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "onboarding-connect-extensions" },
    [
      _c("OnboardingSteps", {
        attrs: {
          "current-step": "extensions",
          "current-network": _vm.currentNetwork,
        },
        on: { "network-selected": _vm.handleNetworkSelected },
      }),
      _c(
        "div",
        { staticClass: "onboarding-content" },
        [
          _c("div", { staticClass: "onboarding-header" }, [
            _c("img", {
              staticClass: "onboarding-network-icon",
              attrs: {
                src: _vm.currentNetworkIcon,
                alt: _vm.currentNetworkName,
              },
            }),
            _c("div", { staticClass: "onboarding-header-content" }, [
              _c("h1", { staticClass: "onboarding-header-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("onboarding.connect_extensions.connection_title", {
                        networkName: _vm.currentNetworkName,
                      })
                    ) +
                    "\n          "
                ),
                _c(
                  "svg",
                  {
                    staticClass: "native-icon",
                    attrs: {
                      width: "26",
                      height: "26",
                      viewBox: "0 0 64 64",
                      xmlns: "http://www.w3.org/2000/svg",
                      "stroke-width": "3",
                      stroke: "none",
                      fill: "#111827",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M37.34,7.36a.12.12,0,0,1,.18.13c-.47,1.86-2.78,12.63,5.57,19.62,8.16,6.84,8.41,17.13,2.33,24-7.27,8.23-19.84,6.78-25.25,1.37C16.36,48.69,9.44,36.33,21.29,26a.1.1,0,0,1,.16,0c.29,1.23,2.3,9,7.66,10,.25,0,.37-.11.25-.34C27.78,32.6,20.66,17,37.34,7.36Z",
                        "stroke-linecap": "round",
                      },
                    }),
                  ]
                ),
              ]),
              _c("p", { staticClass: "onboarding-header-subtitle" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "onboarding.connect_extensions.connection_subtitle",
                        { networkName: _vm.currentNetworkName }
                      )
                    ) +
                    "\n        "
                ),
              ]),
            ]),
          ]),
          _vm.networkFeatures.length > 0
            ? _c(
                "div",
                { staticClass: "onboarding-features-badges" },
                _vm._l(_vm.networkFeatures, function (feature) {
                  return _c(
                    "span",
                    {
                      key: feature,
                      staticClass: "onboarding-feature-badge",
                      attrs: {
                        "data-tooltip": _vm.$t(
                          `onboarding.features.${feature}.description`
                        ),
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(`onboarding.features.${feature}.title`)
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          !_vm.extensionSuccess
            ? _c("div", { staticClass: "onboarding-extension-guide" }, [
                _vm.extensionInstalled !== true
                  ? _c("div", { staticClass: "onboarding-extension-step" }, [
                      _c("div", { staticClass: "onboarding-step-number" }, [
                        _vm._v("1"),
                      ]),
                      _c("div", { staticClass: "onboarding-step-content" }, [
                        _c("h3", { staticClass: "onboarding-step-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "onboarding.connect_extensions.step1_title"
                              )
                            )
                          ),
                        ]),
                        _c(
                          "p",
                          { staticClass: "onboarding-step-description" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "onboarding.connect_extensions.step1_description"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "onboarding-btn-extension",
                            attrs: { href: _vm.extensionUrl, target: "_blank" },
                          },
                          [
                            _c("img", {
                              staticClass: "onboarding-btn-icon",
                              attrs: {
                                src: require("../assets/icons/extension.svg"),
                                alt: "Extension",
                              },
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "onboarding.connect_extensions.download_extension"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "onboarding-gif-toggle",
                            on: {
                              click: function ($event) {
                                _vm.gifStep1Open = !_vm.gifStep1Open
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "14",
                                  height: "14",
                                  viewBox: "0 0 14 14",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                !_vm.gifStep1Open
                                  ? _c("path", {
                                      attrs: {
                                        d: "M5 2.5L9.5 7L5 11.5",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    })
                                  : _c("path", {
                                      attrs: {
                                        d: "M2.5 5L7 9.5L11.5 5",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                              ]
                            ),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.gifStep1Open
                                    ? _vm.$t(
                                        "onboarding.connect_extensions.tutorial_hide"
                                      )
                                    : _vm.$t(
                                        "onboarding.connect_extensions.tutorial_show"
                                      )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm.gifStep1Open
                          ? _c(
                              "div",
                              {
                                staticClass: "onboarding-gif-container",
                                on: {
                                  click: function ($event) {
                                    return _vm.openLightbox(_vm.extensionGif)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "onboarding-gif",
                                  attrs: {
                                    src: _vm.extensionGif,
                                    alt: "Tutorial extension",
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "onboarding-gif-expand-hint" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "16",
                                          height: "16",
                                          viewBox: "0 0 16 16",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M10 2H14V6",
                                            stroke: "currentColor",
                                            "stroke-width": "1.5",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d: "M6 14H2V10",
                                            stroke: "currentColor",
                                            "stroke-width": "1.5",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d: "M14 2L9 7",
                                            stroke: "currentColor",
                                            "stroke-width": "1.5",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d: "M2 14L7 9",
                                            stroke: "currentColor",
                                            "stroke-width": "1.5",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "onboarding-extension-step" }, [
                  _vm.extensionInstalled !== true
                    ? _c("div", { staticClass: "onboarding-step-number" }, [
                        _vm._v("2"),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "onboarding-step-content" }, [
                    _c("h3", { staticClass: "onboarding-step-title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("onboarding.connect_extensions.step2_title", {
                            networkName: _vm.currentNetworkName,
                          })
                        )
                      ),
                    ]),
                    _c("p", { staticClass: "onboarding-step-description" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "onboarding.connect_extensions.step2_description",
                              { networkName: _vm.currentNetworkName }
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "onboarding-btn-connect",
                        on: { click: _vm.openNetworkWithContext },
                      },
                      [
                        _c("img", {
                          staticClass: "onboarding-btn-icon2",
                          attrs: {
                            src: require("../assets/icons/native-icon.svg"),
                            alt: "native",
                          },
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "onboarding.connect_extensions.connect_pages",
                                { networkName: _vm.currentNetworkName }
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm.networkExtensionGif
                      ? _c(
                          "button",
                          {
                            staticClass: "onboarding-gif-toggle",
                            on: {
                              click: function ($event) {
                                _vm.gifStep2Open = !_vm.gifStep2Open
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "14",
                                  height: "14",
                                  viewBox: "0 0 14 14",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                !_vm.gifStep2Open
                                  ? _c("path", {
                                      attrs: {
                                        d: "M5 2.5L9.5 7L5 11.5",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    })
                                  : _c("path", {
                                      attrs: {
                                        d: "M2.5 5L7 9.5L11.5 5",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                              ]
                            ),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.gifStep2Open
                                    ? _vm.$t(
                                        "onboarding.connect_extensions.tutorial_hide"
                                      )
                                    : _vm.$t(
                                        "onboarding.connect_extensions.tutorial_show"
                                      )
                                ) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.gifStep2Open && _vm.networkExtensionGif
                      ? _c(
                          "div",
                          {
                            staticClass: "onboarding-gif-container",
                            on: {
                              click: function ($event) {
                                return _vm.openLightbox(_vm.networkExtensionGif)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "onboarding-gif",
                              attrs: {
                                src: _vm.networkExtensionGif,
                                alt: `Tutorial ${_vm.currentNetworkName}`,
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "onboarding-gif-expand-hint" },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "16",
                                      height: "16",
                                      viewBox: "0 0 16 16",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M10 2H14V6",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M6 14H2V10",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M14 2L9 7",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M2 14L7 9",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ])
            : _c("div", { staticClass: "onboarding-success-container" }, [
                _c("div", { staticClass: "onboarding-success-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "64",
                        height: "64",
                        viewBox: "0 0 64 64",
                        fill: "none",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "32",
                          cy: "32",
                          r: "32",
                          fill: "#10B981",
                          "fill-opacity": "0.1",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M20 32L28 40L44 24",
                          stroke: "#10B981",
                          "stroke-width": "4",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("h2", { staticClass: "onboarding-success-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("onboarding.connect_extensions.success_title")
                    )
                  ),
                ]),
                _c("p", { staticClass: "onboarding-success-subtitle" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "onboarding.connect_extensions.success_subtitle_generic",
                          { networkName: _vm.currentNetworkName }
                        )
                      ) +
                      "\n      "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "onboarding-success-pages" },
                  _vm._l(_vm.newlyConnectedPages, function (page) {
                    return _c(
                      "div",
                      {
                        key: page.id,
                        staticClass: "onboarding-success-page-card",
                      },
                      [
                        page.avatar && !_vm.imageLoadErrors[page.id]
                          ? _c("img", {
                              staticClass: "onboarding-success-page-avatar",
                              attrs: { src: page.avatar, alt: page.name },
                              on: {
                                error: function ($event) {
                                  return _vm.handleImageError(page.id)
                                },
                              },
                            })
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "onboarding-success-page-avatar avatar-placeholder",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(page.name.charAt(0).toUpperCase()) +
                                    "\n          "
                                ),
                              ]
                            ),
                        _c(
                          "div",
                          { staticClass: "onboarding-success-page-info" },
                          [
                            _c(
                              "h4",
                              { staticClass: "onboarding-success-page-name" },
                              [_vm._v(_vm._s(page.name))]
                            ),
                            _c(
                              "p",
                              {
                                staticClass: "onboarding-success-page-username",
                              },
                              [_vm._v("@" + _vm._s(page.username || page.name))]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "onboarding-success-page-badge" },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "16",
                                  height: "16",
                                  viewBox: "0 0 16 16",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M13.333 4L5.99967 11.3333L2.66634 8",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "onboarding.connect_extensions.success_page_badge"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _c("p", { staticClass: "onboarding-success-footer" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("onboarding.connect_extensions.success_footer")
                      ) +
                      "\n      "
                  ),
                ]),
              ]),
          _c("modal-popup", { staticClass: "onboarding-warning-modal" }),
          _c("div", { staticClass: "onboarding-footer-container" }, [
            _c(
              "div",
              {
                staticClass: "onboarding-footer",
                class: { centered: _vm.extensionSuccess },
              },
              [
                !_vm.extensionSuccess
                  ? _c(
                      "button",
                      {
                        staticClass: "onboarding-btn-secondary",
                        on: { click: _vm.skipExtension },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("onboarding.connect_extensions.skip_step")
                            ) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "button",
                  {
                    staticClass: "onboarding-btn-primary",
                    attrs: { disabled: !_vm.extensionSuccess },
                    on: { click: _vm.goToNextPage },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.nextButtonLabel) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _c("transition", { attrs: { name: "lightbox-fade" } }, [
        _vm.gifLightboxSrc
          ? _c(
              "div",
              {
                staticClass: "onboarding-gif-lightbox",
                on: {
                  click: function ($event) {
                    if ($event.target !== $event.currentTarget) return null
                    return _vm.closeLightbox.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "onboarding-gif-lightbox-close",
                    on: { click: _vm.closeLightbox },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "20",
                          height: "20",
                          viewBox: "0 0 20 20",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M15 5L5 15",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M5 5L15 15",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _c("img", {
                  staticClass: "onboarding-gif-lightbox-img",
                  attrs: { src: _vm.gifLightboxSrc, alt: "Tutorial" },
                }),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }